// extracted by mini-css-extract-plugin
export default {"VerticalBarsGraph":"VerticalBarsGraph-module-e9738ae80b883f771173","keyWrapper":"VerticalBarsGraph-module-b4b80a11e2526afce5a1"};